<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
  <div
    class="flex max-h-full w-full shrink-0 grow-0 flex-col items-center gap-4 overflow-auto rounded-md bg-White p-4 transition-[height] transition-discrete duration-1000">
    <div class="group relative flex w-full grow-0 items-center justify-between pr-4">
      <IconSearch :filled="true" class="mr-4 shrink-0 !mb-0 w-10" />
      <label for="search" class="sr-only">Search</label>
      <input id="search" :placeholder="$t('search.placeholder')" ref="searchInput" v-model="searchQuery"
        class="group-hover-focus:placeholder:text-Blue-Primary placeholder:text-black h-full w-full rounded-md border-b border-b-transparent bg-transparent p-2 outline-none placeholder:transition-colors hover:bg-Blue-Primary/20"
        type="text" name="search" />
      <IconX v-if="searchQuery" @click="((searchQuery = ''), close())"
        class="ml-3 size-10 cursor-pointer text-Blue-Secondary"></IconX>
    </div>
    <AlgoliaSearchResults v-if="online" :search-query="searchQuery" />
    <FuseSearchResults v-else :search-query="searchQuery" class="grow" />
  </div>
</template>

<script setup lang="ts">
import { useRouteQuery } from '@vueuse/router'
import AlgoliaSearchResults from './AlgoliaSearchResults.vue'
import FuseSearchResults from './FuseSearchResults.vue'

const searchInput = ref<HTMLInputElement | null>(null)

const searchQuery = useRouteQuery('q', '')

const online = useOnline()

const isSearchOpen = computed(() => searchQuery.value !== '')

onMounted(() => {
  watch(isSearchOpen, (newVal) => {
    if (!newVal) {
      emit('close')
    } else {
      emit('open')
    }
  },
    { immediate: true })
})

//emit if closed
const emit = defineEmits(['close', 'open'])
const close = () => {
  emit('close')
}
</script>
